
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./react-toastify.cjs.production.min.js')
} else {
  module.exports = require('./react-toastify.cjs.development.js')
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-toastify/dist/index.js
 ** module id = 26
 ** module chunks = 0
 **/